// Uses vue-load-image library with standard templating and content

<template>
  <vue-load-image 
    :class="wrapperClass" 
    >
    <template slot="image">
      <img
        :class="imageClass"
        :alt="alt"
        :src="src"
        @load="imageLoad"
        @error="handleImageError"
        @click="click"
      />
    </template>
    <template slot="preloader">
      <div class="wf-load-image-status">
        <div class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </template>
    <template slot="error">
      <div :class="'wf-load-image-status ' + noImageStyles">
        <span class="png-icon png-icon-icons-glyph--k-info">
        </span>
        <p class="my-2 text-center">
          Sorry - this image is unavailable.
        </p>
      </div>
    </template>
  </vue-load-image>
</template>

<script>

import VueLoadImage from 'vue-load-image';
import { globalIcons } from '../../constants/global';

export default {
  props: {
    wrapperClass: {
      type: String,
      required: true
    },
    imageClass: {
      type: String,
      default: 'image'
    },
    src: {
      type: String,
      required: true
    },
    alt: {
      type: String,
      default: ''
    },
    imageLoad: {
      type: Function,
      default: function() {}
    },
    noImageStyles:{
      type: String,
      default: ''
    },
    click: {
      type:Function,
      default: function() {}
    }
  },
  data(){
    return{
      defaultImage:globalIcons.defaultImage,
    }
  },
  components: {
    'vue-load-image': VueLoadImage,
  },

  methods:{
    handleImageError(event) {
      event.target.src = this.defaultImage;
    },
  }
};

</script>
